import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import moment from 'moment';

import { db, user } from '../../../../firebase';
import { getFirestore, collection, setDoc, getDocs, where, addDoc, Timestamp, query, orderBy, onSnapshot, doc } from 'firebase/firestore';
import ThoughtCloudHeader from '../common/Header/thought-cloud-header';

const ThoughtCloudDashboard = () => {
    const [thoughtCloudData, setThoughtCloudData] = useState([]);

    /*****************
    * ON LOAD
   *****************/
    useEffect(() => {
        document.body.classList.add('thoughtcloud');
        if (user) {
            fetchData();
        }
    }, []);
    /*********************************
    * FIREBASE QUERY TO FETCH DATA
    *  let newDoc= doc.data().map((d) => {
            d.data.date_created.seconds = moment(d.data.date_created.seconds ).format()
        });
    *********************************/
    const fetchData = async () => {
        const q = query(collection(db, 'thoughtcloud'));
        const querySnapshot = await getDocs(q);
        setThoughtCloudData(querySnapshot.docs.map(doc => ({
            id: doc.id,
            data: doc.data()
        })));
        
    }
    const convertDate = (d) => {
        const timeStampDate = d;
        const dateInMillis  = timeStampDate.seconds * 1000;
        var date = new Date(dateInMillis).toDateString() + ' at ' + new Date(dateInMillis).toLocaleTimeString(); 
        return date;
    }
    useEffect(() => {
        console.log(thoughtCloudData);
        
    }, [thoughtCloudData])

    /*****************
     * TOOGGLE CARD CONTENT
     *****************/
    const toggleSection = (p, s) => {
        let parent = document.getElementById(p); 
        let self = document.getElementById(s);
        //SET PARENT HEIGHT TO AUTO
        if(parent.style.height === '200px') {
            parent.style.height = 'auto';
        } else {
            parent.style.height = '200px';
        }

        //MODIFY LINK LABEL
        if(self.innerHTML.indexOf('show more') > -1) {
            self.innerHTML = 'show less';
        } else {
            self.innerHTML = 'show more';
        }
       
    }

    return (
        <>

            <ThoughtCloudHeader />
            <div className="grid-page-wrap">
                <div className='grid-columns-three'>
                    {/* LEFT COL */}
                    <div className='left-col'>
                        <div className="grid-card">
                        {/* <img src="/images/vp-logo.png" width="100%" /> */}
                        </div>
                    </div>
                    {/* MID COL */}
                    <div className=' mid-col'>
                        <div className='grid-card'>
                            <div className="grid-card-header">
                                <div><h4>Capture that passing cloud!</h4></div>
                                <div className="grid-align-end">
                                    <Link to="/thoughtcloud/create" className="btn btn-primary btn-sm">Create a Cloud</Link>
                                </div>
                            </div>
                        </div>
                        {
                            thoughtCloudData.length > 0 ?
                                thoughtCloudData.map((tc, i) => {
                                    return (
                                        <div key={i} className='grid-card' >
                                            <div className="grid-card-2col-header">
                                                <span>
                                                    <h4>{tc.data.title}</h4>
                                                    <p className="txt-12 thick">{convertDate(tc.data.date_created)}</p>
                                                    
                                                </span>
                                                <div className="grid-align-end">
                                                    <span className="mdi mdi-heart-outline"></span>&nbsp;
                                                    <span className="mdi mdi-thumb-up-outline"></span>
                                                </div>
                                            </div><hr />
                                            <div id={`grid-content-${i}`} className="grid-card-content" dangerouslySetInnerHTML={{ __html: tc.data.desc }} style={{ height: "200px", overflow: 'hidden' }}>
                                            </div>
                                            <div  className="grid-card-footer">
                                                <a onClick={() => {toggleSection(`grid-content-${i}`,`toggle-link-${i}`)}} style={{cursor: 'pointer'}}><span id={`toggle-link-${i}`}>show more</span> <span className="mdi mdi-chevron-down"></span></a>  
                                            </div>
                                        </div>
                                    )
                                })
                                : <>Loading...</>
                        }

                    </div>
                    <div className='right-col'>
                        <div className='grid-card'>
                            right
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
export default ThoughtCloudDashboard;